import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/configs',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/views/Signup.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/verify-email',
      name: 'verify-email',
      component: () => import('@/views/VerifyEmail.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/configs',
      name: 'configs',
      component: () => import('@/views/ConfigManager.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/api-keys',
      name: 'api-keys',
      component: () => import('@/views/ApiKeys.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/workstations',
      name: 'workstations',
      component: () => import('@/views/Workstations.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/mms',
      name: 'mms',
      component: () => import('@/views/MmsModels.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/how-to',
      name: 'how-to',
      component: () => import('@/views/HowTo.vue'),
      meta: { requiresAuth: true },
    },
  ],
})

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Wait for auth to initialize
  if (!authStore.initialized) {
    await authStore.initialize()
  }

  const requiresAuth = to.meta.requiresAuth !== false
  const requiresAdmin = to.meta.requiresAdmin === true

  if (requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }

  if (requiresAdmin && !authStore.isAdmin) {
    next({ name: 'configs' })
    return
  }

  next()
})

export default router
